import TicketFormGrid from "../Components/TicketFormGrid";
import {PageTitle} from "../../../_metronic/layout/core";
import {useIntl} from "react-intl";

const TicketPage = (): JSX.Element => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({id: 'MENU.SUPPORT'})}</PageTitle>
      <TicketFormGrid/>
    </>
  );
};

export default TicketPage;
